export function parsePairs(text) {
  const lines=text.trim().split(/\r?\n/).filter(line=>line.trim());
  if(lines.length>10001)throw new Error('Максимум 10 000 пар измерений.');
  const pairs=[];const invalid=[];
  lines.forEach((line,index)=>{
    const delimiter=line.includes('\t')?'\t':line.includes(';')?';':',';
    const columns=line.split(delimiter).map(x=>x.trim());
    const numbers=columns.map(x=>x===''?NaN:Number(x.replace(',','.')));
    if(index===0&&columns.length===2&&columns.every(x=>/[a-zа-я]/i.test(x))&&numbers.every(Number.isNaN))return;
    if(columns.length!==2||numbers.some(x=>!Number.isFinite(x)))invalid.push(index+1);else pairs.push(numbers);
  });
  if(invalid.length)throw new Error('Проверьте строки '+invalid.slice(0,10).join(', ')+': нужны ровно два числовых значения.');
  if(pairs.length<3)throw new Error('Добавьте не менее трёх пар измерений.');
  return pairs;
}
export function compareMethods(pairs){
  const n=pairs.length;const mean=a=>a.reduce((s,x)=>s+x,0)/a.length;
  const x=pairs.map(p=>p[0]),y=pairs.map(p=>p[1]);const mx=mean(x),my=mean(y);
  const diffs=pairs.map(p=>p[1]-p[0]);const bias=mean(diffs);const sd=Math.sqrt(diffs.reduce((s,d)=>s+(d-bias)**2,0)/(n-1));
  const sx=x.reduce((s,v)=>s+(v-mx)**2,0),sy=y.reduce((s,v)=>s+(v-my)**2,0);const cov=pairs.reduce((s,p)=>s+(p[0]-mx)*(p[1]-my),0);
  return {n,bias,sd,lower:bias-1.96*sd,upper:bias+1.96*sd,slope:sx>0?cov/sx:null,intercept:sx>0?my-(cov/sx)*mx:null,r:sx>0&&sy>0?Math.max(-1,Math.min(1,cov/Math.sqrt(sx*sy))):null,points:pairs.map(p=>[(p[0]+p[1])/2,p[1]-p[0]])};
}
